module.exports = __webpack_public_path__ + "static/media/WAP-banner1.ab8a2b49.png";